import type { Locale } from "@/lib/i18n";
import { pl, type WRealizationsTestimonialsTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const wRealizationsTestimonialsTranslations: Record<Locale, WRealizationsTestimonialsTranslations> = {
  pl,
  en,
  de,
};

export type { WRealizationsTestimonialsTranslations };
